import React from 'react';
// Import components
import { useFormContext } from 'react-hook-form';
import FileUpload from './FileUpload/FileUpload';

const UploadInvitation = () => {
  const { register } = useFormContext();

  const fileValidation = (uploadedFiles) => {
    let error;

    const file = uploadedFiles[0];

    // If a file exists (user hasn't clicked cancel button or something)
    if (file) {
      const PhotoBase64Extension = file.type.split('/')[1]; // => image/png (split at '/' and grab second part 'png')

      if (
        PhotoBase64Extension !== 'png' &&
        PhotoBase64Extension !== 'jpg' &&
        PhotoBase64Extension !== 'jpeg' &&
        PhotoBase64Extension !== 'pdf'
      ) {
        error = 'The selected file must be a JPG, PNG or PDF';
      } else if (file.size > 4194304) {
        error = 'The selected file must be smaller than 4MB';
      }
    }

    return error;
  };

  const fileUploadValidation = register({
    required: 'Select a photo',
    validate: {
      fileValid: (value) => fileValidation(value) && fileValidation(value),
    },
  });

  return (
    <>
      <FileUpload name="UploadInvitation" fieldValidation={fileUploadValidation} />
    </>
  );
};

export default UploadInvitation;
